var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('collection-upload-box',{attrs:{"colID":_vm.colID,"boxHeight":"300px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }